module.exports = __webpack_public_path__ + "static/mobile_payment_success-71bd66a3b17a7390e03c8a85573a13de.png";